import horizonAPI from '@/api/horizon'
import axios from 'axios'
import {
  FETCH_CONTENT_ERROR,
  FETCH_PAGE_DATA,
  FETCH_COMPONENT_DATA,
  FETCH_EVENTS_DATA,
  FETCH_ARTICLES_DATA,
  FETCH_NEWSLETTER_DATA
} from './types'
import {
  formatArray,
  formatObject,
  formatKeys,
  formatJsonURL,
  keyFromPath
} from '@/utils/dataFormatting'
import * as dateParser from '@/utils/dateParser'

const formattedURL = path => {
  return `${formatJsonURL(path)}?v=${Math.random()}`
}

const removePastEvents = events => {
  return events.filter(event => {
    let passedStartDate = dateParser.hasDatePassed(event.dates.start_date)
    let passedEndDate = dateParser.hasDatePassed(event.dates.end_date)

    return !passedStartDate || !passedEndDate
  })
}

export const fetchPageData = (path, page) => async dispatch => {
  const response = await actionFetch({ path: formattedURL(`${path}.json`) })
  dispatch({
    type: FETCH_PAGE_DATA,
    payload: {
      data: formatKeys(formatArray(response.data.contents)),
      page
    }
  })
}

export const fetchComponentData = (path, page, id) => async dispatch => {
  const response = await actionFetch({ path: formattedURL(path) })
  // const response = await axios.get(`/mockData/${path}`);
  const data = {
    type: response.data.contents[0].contentName,
    content: formatKeys(formatObject(response.data.contents[0]))
  }
  dispatch({
    type: FETCH_COMPONENT_DATA,
    payload: {
      data,
      page,
      id
    }
  })
}

export const fetchEventsData = path => async dispatch => {
  const response = await actionFetch({ path: formattedURL(path) })
  dispatch({
    type: FETCH_EVENTS_DATA,
    payload: {
      id: keyFromPath(path),
      data: removePastEvents(formatKeys(formatArray(response.data.contents)))
    }
  })
}

export const fetchArticlesData = path => async dispatch => {
  const response = await actionFetch({ path: formattedURL(path) })
  dispatch({
    type: FETCH_ARTICLES_DATA,
    payload: {
      data: formatKeys(formatArray(response.data.contents))
    }
  })
}

export const fetchNewsletterData = path => async dispatch => {
  const response = await actionFetch({ path: formattedURL(path) })
  dispatch({
    type: FETCH_NEWSLETTER_DATA,
    payload: {
      data: formatKeys(formatArray(response.data.contents))
    }
  })
}

const actionFetch = async ({ path }) => {
  try {
    const response = await horizonAPI.get(path)
    return response
  } catch (error) {
    dispatch({ type: FETCH_CONTENT_ERROR, payload: error })
  }
}



// WEBPACK FOOTER //
// ./src/services/contentEvents/actions.js